<template>
  <div v-if="content" v-editable="content" id="blog">
    <component :content="blok" :key="blok._uid" v-for="blok in blog.body" :is="blok.component"></component>
    <div class="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-16 py-16">
      <component
        :content="blok.content"
        :key="blok._uid"
        v-for="blok in content"
        :is="blok.content.component"
        :meta="blok"
      ></component>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "blog",
  data() {
    return {
      content: null,
      blog: null
    };
  },
  created() {
    this.fetchData();
    if (this.$storyblok) {
      this.$storyblok.init();
      this.$storyblok.on(["change", "published"], () =>
        window.location.reload()
      );
      this.$storyblok.on("input", ({ story }) => {
        this.content = story.content;
      });
    }
  },
  methods: {
    async fetchData() {
      const { data } = await api.get(`cdn/stories`, {
        starts_with: `${this.$i18n.locale}/blog`,
        sort_by: "created_at:desc"
      });
      const res = await api.get(`cdn/stories/${this.$i18n.locale}/pages/blog`);

      this.blog = res.data.story.content;
      this.content = data.stories;
    }
  }
};
</script>

